import React from 'react';

import Meta from '@bizapp-lp/home/organisms/Meta';
import { Complete } from '@bizapp-lp/home/templates/Complete';

const title =
  'HUE Works Suite 無効なページ | 株式会社ワークスアプリケーションズ';
const description =
  '株式会社ワークスアプリケーションズがご提供するHUE Works Suiteに関するページです。';

const Page: React.FC = () => {
  return (
    <>
      <Meta>
        <title>{title}</title>
        <meta name="description" content={description} />
        <meta property="og:title" content={title} />
        <meta property="og:description" content={description} />
      </Meta>
      <Complete
        heading1="HUE Works Suite 無効ページ"
        heading2="無効なページです"
        description="申し訳ありません、こちらのページは無効となっております。"
      />
    </>
  );
};

const Invalid = React.memo(Page);
export default Invalid;
